import { NgModule, ModuleWithProviders } from '@angular/core';
import { LogObserverService } from './log-observer.service';

@NgModule({
	imports: [
	],
	exports: [
	],
	providers: [
		LogObserverService
	]
})
export class LogModule { }